module.exports = __webpack_public_path__ + "static/media/audio.f5d0daa6.svg";